import { sendDataToParentWindow } from 'utilities/domOperation'
import store from 'store'

// The parent chatbot origin we expect the reply to come from — same source the
// sender (sendDataToParentWindow) targets.
function getExpectedParentOrigin() {
  const urlParams = new URLSearchParams(window.location.search)
  const parentUrl =
    store.getters['setting/getSetting']?.parentUrl ||
    localStorage.getItem('parentUrl') ||
    urlParams.get('parentUrl')
  if (!parentUrl) return null
  try {
    return new URL(parentUrl).origin
  } catch {
    return null
  }
}

// Ask the parent chatbot for the anonymous user's session token via postMessage.
// The chatbot only replies to its trusted BW origin, and the token is never put
// in the iframe URL, so it stays out of history/referrer/logs. Resolves with the
// token string, or undefined after the timeout (no chatbot parent, or an older
// chatbot that does not send it yet).
export function requestChatbotAnonymousSession(timeout = 2000) {
  return new Promise((resolve) => {
    const expectedOrigin = getExpectedParentOrigin()

    // cleanup references the timers/handler declared below; it is only ever
    // invoked after they are initialised, so the const bindings are safe.
    const cleanup = () => {
      clearTimeout(timeoutId)
      clearInterval(intervalId)
      window.removeEventListener('message', messageHandler)
    }

    const messageHandler = (event) => {
      // Only trust the reply from the parent chatbot origin — an anonymous
      // session is a bearer credential, so ignore forged messages from any
      // other frame.
      if (expectedOrigin && event.origin !== expectedOrigin) return

      if (event.data?.action === 'getTriplabotAnonymousSession' && event.data.anonymous_session) {
        cleanup()
        resolve(event.data.anonymous_session)
      }
    }

    const timeoutId = setTimeout(() => {
      cleanup()
      resolve()
    }, timeout)

    window.addEventListener('message', messageHandler)

    // maybe CB hasn't loaded when we send this message then retry in 200ms
    const intervalId = setInterval(() => {
      sendDataToParentWindow({ action: 'getTriplabotAnonymousSession' })
    }, 200)
  })
}
